var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDownwardLight = function SvgIconArrowDownwardLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_arrow_downward_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.434 3.633v8.634H7.7V3.633h.734Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.608 12.41c-.297.352-.812.303-1.1.016a.25.25 0 0 1-.006-.007L4.135 8.886l.531-.506 3.362 3.529c.011.01.023.014.03.015a.267.267 0 0 1 .012-.012l3.4-3.533.528.508-3.39 3.524Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_arrow_downward_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-180 6 6.333)",
    d: "M0 0h7.867v9.033H0z"
  })))));
};
export default SvgIconArrowDownwardLight;